import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import RadioChips from '@components/dataEntry/chip/RadioChips';
import {
  BATTLE_TYPE_MAP,
  RSP_TYPE,
  RSP_TYPE_VALUE,
} from '@typings/common/rspType';

const CustomChip = styled.div`
  gap: 4px;
  display: flex;
  font-size: 13px;
  span {
    font-size: 11px;
  }
`;

const RSPWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
`;

type Props = { setBattleResult: any };
function RockSissorsPaper({ setBattleResult }: Props) {
  const [rspValue, setRSP] = useState<RSP_TYPE_VALUE>(RSP_TYPE.ROCK);

  useEffect(() => {
    setBattleResult(rspValue);
  }, [rspValue]);

  return (
    <RSPWrapper>
      <strong>선택</strong>
      <div>
        <RadioChips setKey={setRSP} defaultKey={RSP_TYPE.ROCK} size="sm">
          <CustomChip key={RSP_TYPE.SCISSORS}>
            ✌<span>{BATTLE_TYPE_MAP.scissors}</span>
          </CustomChip>
          <CustomChip key={RSP_TYPE.ROCK}>
            ✊<span>{BATTLE_TYPE_MAP.rock}</span>
          </CustomChip>
          <CustomChip key={RSP_TYPE.PAPER}>
            ✋<span>{BATTLE_TYPE_MAP.paper}</span>
          </CustomChip>
        </RadioChips>
      </div>
    </RSPWrapper>
  );
}

export default RockSissorsPaper;
